<template>
    <div class="home-page">
        <h1 class="main-title">
            <span>CUENTAS STREAMING</span>
        </h1>

        <div class="portfolio-grid">
            <div v-for="(item, index) in sortedPortfolioItems" :key="index" class="portfolio-item" @click="openModal(item)">
                <div class="portfolio-content">
                    <img :src="require(`@/assets/imagenes/${item.imagen}`)" :alt="item.titulo" class="portfolio-image" />
                    <div class="portfolio-info">
                        <h3>
                            {{ item.titulo }}
                            <img src="@/assets/imagenes/garantizado.png" alt="Garantizado" class="certification-icon" />
                        </h3>
                        <p class="portfolio-description">{{ item.descripcionCorta }}</p>
                        <p class="portfolio-price">${{ item.precio }}/mes</p>
                    </div>
                </div>
            </div>
        </div>

        <teleport to="body">
            <transition name="modal">
                <div v-if="modalItem" class="modal-backdrop" @click="closeModal">
                    <div class="modal" @click.stop>
                        <button @click="closeModal" class="close-button" aria-label="Cerrar modal">×</button>

                        <h2 class="modal-title">
                            {{ modalItem.titulo }}
                            <img src="@/assets/imagenes/garantizado.png" alt="Garantizado" class="certification-icon" />
                        </h2>

                        <img :src="require(`@/assets/imagenes/${modalItem.imagen}`)" :alt="modalItem.titulo" class="modal-image" />

                        <p class="modal-description">{{ modalItem.descripcion }}</p>
                        <ul class="modal-details">
                            <li v-for="(detalle, index) in modalItem.detalles" :key="index">{{ detalle }}</li>
                        </ul>

                        <div class="modal-price-quantity">
                            <p class="modal-price">${{ modalItem.precio }}/mes</p>
                            <div class="quantity-total">
                                <div class="quantity-selector">
                                    <button @click="decreaseQuantity" :disabled="modalItem.quantity <= 1">-</button>
                                    <span>{{ modalItem.quantity }}</span>
                                    <button @click="increaseQuantity">+</button>
                                </div>
                                <p class="total-price">Total: ${{ totalPrice.toFixed(2) }}</p>
                            </div>
                        </div>

                        <p class="modal-info-text">
                            ¿Tienes dudas? Consulta nuestras <a href="/#faq" @click="closeModal" class="info-link">preguntas frecuentes</a> o revisa nuestros
                            <router-link to="/metodos-de-pago" @click="closeModal" class="info-link">métodos de pago</router-link>.
                        </p>

                        <div class="terms-checkbox">
                            <input type="checkbox" id="accept-terms" v-model="termsAccepted" class="larger-checkbox" />
                            <label for="accept-terms">
                                Acepto los <router-link to="/terminos-de-uso" target="_blank" class="terms-link">términos y condiciones</router-link> del servicio
                            </label>
                        </div>

                        <a :href="whatsappLink" target="_blank" class="whatsapp-button" :class="{ disabled: !termsAccepted }" @click.prevent="orderViaWhatsApp">
                            <font-awesome-icon :icon="['fab', 'whatsapp']" /> Ordenar vía WhatsApp
                        </a>
                    </div>
                </div>
            </transition>
        </teleport>

        <FAQ />

        <footer-component />

        <Notification :show="showNotification" :message="notificationMessage" :type="notificationType" @close="closeNotification" />
    </div>
</template>

<script>
import { ref, computed } from 'vue';
import FAQ from '@/components/FAQ.vue';
import Notification from '@/components/Notification.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
    name: 'HomePage',
    components: {
        FAQ,
        Notification,
        FooterComponent,
    },
    setup() {
        const modalItem = ref(null);
        const termsAccepted = ref(false);
        const showNotification = ref(false);
        const notificationMessage = ref('');
        const notificationType = ref('info');

        const portfolioItems = ref([
            {
                titulo: 'Max Platino - 1 Mes',
                descripcionCorta: 'Accede a Max Platino por un mes y disfruta de contenido exclusivo y premium.',
                descripcion: 'La suscripción a Max Platino te ofrece un mes de acceso a un catálogo exclusivo de contenido de alta calidad.',
                detalles: ['Cuenta facturada', 'Dominio del cliente', '1 mes de garantía'],
                precio: 6.8,
                quantity: 1,
                color: 'var(--color-hbo)',
                imagen: 'max.jpg',
                position: 1,
            },
            /*{
                titulo: 'YouTube Familiar 1 mes',
                descripcionCorta: 'Disfruta de YouTube Familiar por un mes, ideal para toda la familia.',
                descripcion: 'Con la suscripción a YouTube Familiar por un mes, tendrás acceso a contenido variado y adecuado para todas las edades.',
                detalles: ['Cuenta facturada', 'Dominio del cliente', '1 mes de garantía'],
                precio: 5.5,
                quantity: 1,
                color: 'var(--color-youtube)',
                imagen: 'youtube.jpg',
                position: 2,
            },*/
            {
                titulo: 'YouTube Individual 1 mes',
                descripcionCorta: 'Accede a YouTube Premium por un mes y disfruta de contenido sin interrupciones.',
                descripcion: 'La suscripción a YouTube Individual por un mes te permite disfrutar de videos sin anuncios y acceso a contenido exclusivo.',
                detalles: ['Cuenta facturada', 'Dominio del cliente', '1 mes de garantía'],
                precio: 3,
                quantity: 1,
                color: 'var(--color-youtube)',
                imagen: 'youtube.jpg',
                position: 3,
            },
            /*{
                titulo: 'YouTube Individual 1 mes',
                descripcionCorta: 'Accede a YouTube Premium por un mes y disfruta de contenido sin interrupciones.',
                descripcion: 'La suscripción a YouTube Individual por un mes te permite disfrutar de videos sin anuncios y acceso a contenido exclusivo.',
                detalles: ['Agregada a Plan Familiar', 'Dominio del cliente', '1 mes de garantía'],
                precio: 2,
                quantity: 1,
                color: 'var(--color-youtube)',
                imagen: 'youtube.jpg',
                position: 4,
            },
            {
                titulo: 'YouTube Individual 2 meses',
                descripcionCorta: 'Agrega YouTube Individual por 2 meses a un plan familiar',
                descripcion:
                    'Esta suscripción te permite agregar YouTube Individual a un plan familiar por 2 meses y te permite disfrutar de videos sin anuncios y acceso a contenido exclusivo.',
                detalles: ['Agregada a plan familiar', 'Dominio del cliente', '2 meses de garantía'],
                precio: 3,
                quantity: 1,
                color: 'var(--color-youtube)',
                imagen: 'youtube.jpg',
                position: 5,
            },*/
            {
                titulo: 'Spotify Familiar 1 mes',
                descripcionCorta: 'Disfruta de Spotify Familiar por un mes con acceso a música ilimitada.',
                descripcion: 'Con la suscripción a Spotify Familiar por un mes, tendrás acceso a música ilimitada para toda la familia.',
                detalles: ['Cuenta facturada', 'Garantía de activación', 'Se entrega correo y contraseña', 'IP Nigeria'],
                precio: 5.5,
                quantity: 1,
                color: 'var(--color-spotify)',
                imagen: 'spotify.jpg',
                position: 6,
            },
            {
                titulo: 'Spotify Familiar 1 mes',
                descripcionCorta: 'Disfruta de Spotify Familiar por un mes con acceso a música ilimitada.',
                descripcion: 'Con la suscripción a Spotify Familiar por un mes, tendrás acceso a música ilimitada para toda la familia.',
                detalles: ['Cuenta facturada', 'Garantía de activación', 'Se entrega correo y contraseña', 'IP Argentina'],
                precio: 4.5,
                quantity: 1,
                color: 'var(--color-spotify)',
                imagen: 'spotify.jpg',
                position: 7,
            },
            {
                titulo: 'Spotify Individual 1 mes',
                descripcionCorta: 'Disfruta de Spotify Individual por un mes a un precio increíble.',
                descripcion: 'La suscripción a Spotify Individual por un mes te permite acceder a música ilimitada.',
                detalles: ['1 mes de garantía', 'Se entrega correo y contraseña'],
                precio: 1.75,
                quantity: 1,
                color: 'var(--color-spotify)',
                imagen: 'spotify.jpg',
                position: 8,
            },
            /*{
                titulo: 'Spotify Individual 3 meses',
                descripcionCorta: 'Accede a Spotify Individual por 3 meses y disfruta de música sin límites.',
                descripcion: 'Con la suscripción a Spotify Individual por 3 meses, tendrás acceso a un catálogo musical ilimitado',
                detalles: ['3 meses de garantía', 'Se entrega correo y contraseña'],
                precio: 4,
                quantity: 1,
                color: 'var(--color-spotify)',
                imagen: 'spotify.jpg',
                position: 9,
            },*/
            {
                titulo: 'Prime Video 1 mes',
                descripcionCorta: 'Disfruta de Prime Video por un mes y accede a un vasto catálogo de entretenimiento.',
                descripcion:
                    'La suscripción a Prime Video por un mes te brinda la oportunidad de explorar un vasto catálogo de contenido, que incluye películas, series originales y programas de televisión',
                detalles: ['Cuenta facturada', '1 mes de garantía', 'Dominio del cliente'],
                precio: 3,
                quantity: 1,
                color: 'var(--color-amazon)',
                imagen: 'amazonprime.jpg',
                position: 9,
            },
        ]);

        const sortedPortfolioItems = computed(() => {
            return [...portfolioItems.value].sort((a, b) => a.position - b.position);
        });

        const totalPrice = computed(() => {
            return modalItem.value ? modalItem.value.precio * modalItem.value.quantity : 0;
        });

        const whatsappLink = computed(() => {
            if (!modalItem.value) return '';

            const message = encodeURIComponent(
                `*¡Hola!* Me interesa comprar ${modalItem.value.quantity} cuenta(s) de _${modalItem.value.titulo}_.\n\n` +
                    `*Detalles de la compra:*\n` +
                    `- *Servicio:* _${modalItem.value.titulo}_\n` +
                    `- *Cantidad:* ${modalItem.value.quantity}\n` +
                    `- *Precio unitario:* $${modalItem.value.precio}\n` +
                    `- *Total:* $${totalPrice.value.toFixed(2)}\n\n` +
                    `Por favor, proporcióname más información sobre cómo proceder con la compra. ¡Gracias!`
            );

            return `https://wa.me/50764182919?text=${message}`;
        });

        const openModal = (item) => {
            modalItem.value = { ...item };
            termsAccepted.value = false;
        };

        const closeModal = () => {
            modalItem.value = null;
        };

        const increaseQuantity = () => {
            if (modalItem.value) {
                modalItem.value.quantity++;
            }
        };

        const decreaseQuantity = () => {
            if (modalItem.value && modalItem.value.quantity > 1) {
                modalItem.value.quantity--;
            }
        };

        const orderViaWhatsApp = (event) => {
            if (!termsAccepted.value) {
                event.preventDefault();
                showNotification.value = true;
                notificationMessage.value = 'Por favor, acepta los términos y condiciones antes de realizar tu pedido.';
                notificationType.value = 'warning';
            } else {
                window.open(whatsappLink.value, '_blank');
            }
        };

        const closeNotification = () => {
            showNotification.value = false;
        };

        return {
            modalItem,
            termsAccepted,
            showNotification,
            notificationMessage,
            notificationType,
            portfolioItems,
            sortedPortfolioItems,
            totalPrice,
            whatsappLink,
            openModal,
            closeModal,
            increaseQuantity,
            decreaseQuantity,
            orderViaWhatsApp,
            closeNotification,
        };
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap');

.home-page {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem 2rem;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.main-title {
    font-family: 'Poppins', sans-serif;
    font-size: 3.5rem;
    font-weight: 700;
    text-align: center;
    margin: 2rem 0;
    color: var(--color-text);
    position: relative;
    overflow: hidden;
    padding: 0.5rem 1rem;
}

.main-title::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4px;
    background-color: var(--color-accent);
    transform: translateX(-100%);
    animation: underline 2s ease-in-out infinite alternate;
}

@keyframes underline {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
}

.main-title span {
    display: block;
    opacity: 0;
    animation: fadeIn 0.5s ease-out forwards;
}

.main-title span:nth-child(1) {
    animation-delay: 0.2s;
}

.main-title span:nth-child(2) {
    animation-delay: 0.4s;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.portfolio-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    flex-grow: 1;
    margin: 2rem 0;
}

.portfolio-item {
    background: var(--color-card);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    transform: translateY(20px);
    opacity: 0;
    animation: fadeInUp 0.6s ease forwards;
}

.portfolio-item:nth-child(1) {
    animation-delay: 0.1s;
}
.portfolio-item:nth-child(2) {
    animation-delay: 0.2s;
}
.portfolio-item:nth-child(3) {
    animation-delay: 0.3s;
}
.portfolio-item:nth-child(4) {
    animation-delay: 0.4s;
}
.portfolio-item:nth-child(5) {
    animation-delay: 0.5s;
}
.portfolio-item:nth-child(6) {
    animation-delay: 0.6s;
}

@keyframes fadeInUp {
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.portfolio-item:hover {
    transform: translateY(-5px);
    border-color: var(--color-accent);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.portfolio-content {
    padding: 1.5rem;
}

.portfolio-image {
    width: auto;
    height: auto;
    border-radius: 12px;
    margin: 0 auto 1rem;
    display: block;
    transition: transform 0.3s ease;
}

.portfolio-item:hover .portfolio-image {
    transform: scale(1.05);
}

.portfolio-info {
    text-align: center;
}

.portfolio-info h3 {
    color: var(--color-text);
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    text-align: center;
}

.portfolio-description {
    color: var(--color-text-muted);
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
}

.portfolio-price {
    color: var(--color-accent);
    font-weight: bold;
    font-size: 1.2rem;
}

/* Modal Styles */
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal {
    background: var(--color-background);
    border: 1px solid var(--color-border);
    backdrop-filter: blur(16px);
    padding: 1.25rem;
    border-radius: 20px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    max-width: 450px;
    width: 90%;
    position: relative;
    min-height: 70%;
    max-height: 80%;
    overflow-y: auto;
}

.close-button {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    background: none;
    border: none;
    color: var(--color-text);
    font-size: 2rem;
    cursor: pointer;
    transition: transform 0.3s ease;
    padding: 0.5rem;
    border-radius: 50%;
    z-index: 10;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: rotate(90deg);
}

.modal-title {
    font-size: 1.6rem;
    text-align: center;
    margin-bottom: 0.75rem;
    color: var(--color-text);
    display: flex;
    align-items: center;
    justify-content: center;
}

.certification-icon {
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-left: 5px;
}

.modal-image {
    width: auto;
    height: auto;
    max-height: 130px;
    object-fit: cover;
    border-radius: 12px;
    margin: 0 auto 1.5rem;
    display: block;
}

.modal-description {
    color: var(--color-text-muted);
    line-height: 1.6;
    margin-bottom: 0.75rem;
    font-size: 0.85rem;
}

.modal-price-quantity {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    margin-bottom: 0.75rem;
    background: var(--color-background-light);
    padding: 0.6rem;
    border-radius: 12px;
}

.modal-price {
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--color-accent);
}

.quantity-selector {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    justify-content: center;
}

.quantity-selector button {
    background: linear-gradient(to right, var(--color-primary), var(--color-secondary));
    color: white;
    border: none;
    padding: 0.4rem 0.6rem;
    border-radius: 8px;
    font-weight: bold;
}

.quantity-selector button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.quantity-selector span {
    background: var(--color-background);
    padding: 0.4rem 0.6rem;
    border-radius: 8px;
    min-width: 2.5rem;
    text-align: center;
}

.total-price {
    font-weight: bold;
    color: var(--color-accent);
    text-align: center;
    width: 100%;
    margin-top: 0.5rem;
}

.modal-info-text {
    text-align: center;
    margin-bottom: 0.75rem;
    color: var(--color-text-muted);
}

.info-link {
    color: var(--color-accent);
    text-decoration: underline;
}

.terms-checkbox {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    padding: 0.6rem;
    background: var(--color-background-light);
    border-radius: 12px;
}

.larger-checkbox {
    width: 1.2rem;
    height: 1.2rem;
    accent-color: var(--color-accent);
}

.terms-link {
    color: var(--color-accent);
    text-decoration: underline;
}

.whatsapp-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: auto;
    padding: 0.6rem;
    background: linear-gradient(to right, #25d366, #128c7e);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    margin: 0 auto;
}

.whatsapp-button:hover:not(.disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
}

.whatsapp-button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

@keyframes iconBounce {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-10px);
    }
}

@media (max-width: 768px) {
    .whatsapp-button {
        width: auto;
        margin: 0.5rem;
        font-size: 0.9rem;
    }
    .modal {
        padding: 1rem;
        max-height: 80vh;
    }

    .modal-title {
        font-size: 1.4rem;
    }

    .modal-image {
        max-height: 110px;
    }

    .modal-description {
        font-size: 0.8rem;
    }
}

@media (max-width: 480px) {
    .main-title {
        font-size: 2rem;
    }

    .title-icon {
        font-size: 1.5rem;
    }

    .portfolio-content {
        padding: 1rem;
    }

    .modal-title {
        font-size: 1.2rem;
    }
}
</style>
